import { useEffect, useRef, useState } from "react";
import { Card } from "../../../../../components";
import { events } from "../../data/testmock";
import { EventCard } from "../EventCard/EventCard";

export const EyeForDates = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [isHovered, setIsHovered] = useState(false);
  const animationRef = useRef<number>();
  const waitTimeoutRef = useRef<NodeJS.Timeout>();

  useEffect(() => {
    const container = containerRef.current;
    let counter = 0;
    if (!container) {
      return;
    }

    const resetScroll = () => {
      if (containerRef.current) {
        containerRef.current.scrollLeft = 0;
        // Restart the animation immediately after reset
        if (!isHovered) {
          animationRef.current = requestAnimationFrame(animate);
        }
      }
    };

    const animate = () => {
      const container = containerRef.current;
      if (container && !isHovered) {
        if (
          container.scrollLeft >=
          container.scrollWidth - container.clientWidth
        ) {
          // At the end, wait 5 seconds before resetting
          waitTimeoutRef.current = setTimeout(() => {
            resetScroll();
          }, 5000);
          return;
        }

        container.scrollLeft += counter % 2;
        counter++;
        animationRef.current = requestAnimationFrame(animate);
      }
    };

    animationRef.current = requestAnimationFrame(animate);

    return () => {
      if (animationRef.current) {
        cancelAnimationFrame(animationRef.current);
      }
      if (waitTimeoutRef.current) {
        clearTimeout(waitTimeoutRef.current);
      }
    };
  }, [isHovered]);

  return (
    <Card disableWatermark>
      <div className="flex flex-col gap-[10px] max-w-full">
        <div className="flex justify-between">
          <h2 className="font-bold text-base">Keep an eye for the dates</h2>
          {/* <a href="/" className="text-xx-blue-500 font-medium">
            {"View all >"}
          </a> */}
        </div>
        <div
          ref={containerRef}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          className="flex gap-[10px] overflow-x-hidden overscroll-contain max-w-full"
        >
          {events?.map((event) => (
            <EventCard
              key={`${event.name}${event.date}`}
              date={event.date}
              name={event.name}
              changeDirection={
                event.changeDirection as "up" | "down" | "unknown"
              }
              tokens={event.tokens}
            />
          ))}
        </div>
      </div>
    </Card>
  );
};
